import React from 'react';
import AnimatedPage from '../components/AnimatedPage';

const AestheticServices = () => {
  return (
    <AnimatedPage className="min-h-screen bg-stone-50">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
              Venus Bliss MAX™ Body Contouring
            </h1>
            <div className="h-1 w-24 bg-gradient-to-r from-amber-500 via-amber-500 to-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="pt-8 pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-stone-900 mb-10 text-center">How it WORKS</h2>
          
          <div className="space-y-12">
            {/* Fat Reduction */}
            <div className="bg-gradient-to-br from-stone-50 to-amber-50 rounded-xl p-8 shadow-lg border-2 border-stone-100">
              <div className="flex flex-col md:flex-row items-center gap-6">
                {/* Text Content */}
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-stone-900 mb-4">FAT REDUCTION</h3>
                  <p className="text-stone-700 leading-relaxed">
                    Laser energy gently heats the fat and targets the deeper layers where it accumulates. This triggers the body's natural process of breaking down fat cells, which are gradually eliminated through the lymphatic system. Some patients may see up to 20% reduction of abdominal fat.*
                  </p>
                </div>
                {/* Image on Right */}
                <div className="flex-shrink-0">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/xuptm7h1_image.png" 
                    alt="Fat Reduction Treatment Device"
                    className="w-64 h-64 object-cover rounded-full shadow-lg border-4 border-white"
                  />
                </div>
              </div>
            </div>

            {/* Muscle Conditioning */}
            <div className="bg-gradient-to-br from-stone-50 to-amber-50 rounded-xl p-8 shadow-lg border-2 border-stone-100">
              <div className="flex flex-col md:flex-row items-center gap-6">
                {/* Text Content */}
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-stone-900 mb-4">MUSCLE CONDITIONING</h3>
                  <p className="text-stone-700 leading-relaxed">
                    Hands-free FlexMAX Electrical Muscle Stimulation treatment intelligently targets 7 different muscle groups and mimics real workouts, delivering up to 100,000 muscle contractions in just 30 minutes.
                  </p>
                </div>
                {/* Image on Right */}
                <div className="flex-shrink-0">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/dwfxhh16_image.png" 
                    alt="Muscle Conditioning Treatment Device"
                    className="w-64 h-64 object-cover rounded-full shadow-lg border-4 border-white"
                  />
                </div>
              </div>
            </div>

            {/* Skin & Cellulite Treatment */}
            <div className="bg-gradient-to-br from-stone-50 to-amber-50 rounded-xl p-8 shadow-lg border-2 border-stone-100">
              <div className="flex flex-col md:flex-row items-center gap-6">
                {/* Text Content */}
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-stone-900 mb-4">SKIN & CELLULITE TREATMENT</h3>
                  <p className="text-stone-700 leading-relaxed">
                    Proprietary (MP)² combines Multi-Polar Radio Frequency (RF) to boost collagen and elastin production and Pulsed Electro Magnetic Fields (PEMF) to support the body's natural healing process. Integrated VariPulse™ technology uses a massage-like motion to improve blood circulation and target stubborn cellulite for effective body sculpting.
                  </p>
                </div>
                {/* Image on Right */}
                <div className="flex-shrink-0">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/o2o7m5aq_image.png" 
                    alt="Skin and Cellulite Treatment Device"
                    className="w-64 h-64 object-cover rounded-full shadow-lg border-4 border-white"
                  />
                </div>
              </div>
            </div>
          </div>

          <p className="text-sm text-stone-500 text-center mt-8 italic">
            *Clinical study on file. Results may vary.
          </p>
        </div>
      </section>

      {/* What to Expect Section */}
      <section className="py-16 bg-gradient-to-br from-stone-100 to-amber-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-8 text-center text-stone-900">What to EXPECT</h2>
          
          <p className="text-lg text-center mb-12 max-w-4xl mx-auto text-stone-700">
            Venus Bliss MAX's advanced 3-in-1 solution works on fat, muscle, and skin effectively, safely and comfortably. Customizable treatment plans ensure optimal results and satisfaction.
          </p>

          <div className="space-y-6 max-w-4xl mx-auto">
            {/* Fat Reduction */}
            <div className="bg-gradient-to-r from-amber-500 to-orange-600 rounded-full p-6 flex items-center justify-around shadow-lg">
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">25</div>
                <div className="text-sm">Minutes</div>
              </div>
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">1</div>
                <div className="text-sm">Treatment / Month</div>
              </div>
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">3</div>
                <div className="text-sm">Treatments</div>
              </div>
            </div>
            <div className="text-center font-bold text-xl text-stone-900">FAT REDUCTION</div>

            {/* Muscle Conditioning */}
            <div className="bg-gradient-to-r from-amber-500 to-orange-600 rounded-full p-6 flex items-center justify-around shadow-lg">
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">30</div>
                <div className="text-sm">Minutes</div>
              </div>
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">1–2</div>
                <div className="text-sm">Treatments / Week</div>
              </div>
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">6</div>
                <div className="text-sm">Treatments</div>
              </div>
            </div>
            <div className="text-center font-bold text-xl text-stone-900">MUSCLE CONDITIONING</div>

            {/* Skin & Cellulite Treatment */}
            <div className="bg-gradient-to-r from-amber-500 to-orange-600 rounded-full p-6 flex items-center justify-around shadow-lg">
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">30</div>
                <div className="text-sm">Minutes</div>
              </div>
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">1</div>
                <div className="text-sm">Treatment / Week</div>
              </div>
              <div className="text-center text-white">
                <div className="text-4xl font-bold mb-2">8–10</div>
                <div className="text-sm">Treatments</div>
              </div>
            </div>
            <div className="text-center font-bold text-xl text-stone-900">SKIN & CELLULITE TREATMENT</div>
          </div>

          <p className="text-sm text-stone-600 text-center mt-8 italic">
            Treatment time depends on treated area. Treatment plans vary by individual.
          </p>
        </div>
      </section>

      {/* QR Code Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-8">
            {/* Text on Left */}
            <p className="text-xl text-stone-700 leading-relaxed">
              Scan the QR code to know more about Aesthetic Services
            </p>
            
            {/* QR Code on Right */}
            <div className="flex-shrink-0">
              <img
                src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/ioizrgyv_Contact_Us_QR_Code.png"
                alt="Aesthetic Services QR Code"
                className="w-32 h-32 object-contain"
              />
            </div>
          </div>
          
          {/* Cherry Payment Link */}
          <div className="mt-8 text-center">
            <p className="text-base text-stone-700">
              Use Cherry payment option to make your wellness goals more affordable at{' '}
              <a 
                href="https://pay.withcherry.com/crofton-family-practice" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-amber-600 hover:text-amber-700 font-medium underline"
              >
                https://pay.withcherry.com/crofton-family-practice
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Patient Testimonials Section */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3">
              What Patients Are Saying
            </h2>
            <div className="h-1 w-24 bg-gradient-to-r from-amber-500 via-amber-500 to-orange-500 mx-auto mb-3"></div>
            <p className="text-base text-stone-600 max-w-3xl mx-auto">
              Real results from our valued patients
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {/* Stacy L Testimonial */}
            <div className="bg-gradient-to-br from-stone-50 to-amber-50 rounded-xl p-8 shadow-lg border-2 border-stone-100">
              <div className="mb-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                    <span className="text-xl font-bold text-amber-600">S</span>
                  </div>
                  <div className="ml-4">
                    <h3 className="font-bold text-stone-900 text-lg">Stacy L</h3>
                    <div className="flex text-amber-500">
                      ★★★★★
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-base text-stone-700 leading-relaxed italic mb-4">
                "I recently experienced Venus Bliss Max™ treatments at Crofton Family Practice and I am genuinely blown away by my results. The results have been really meaningful to me. I practice yoga regularly and could actually see the difference in my poses — that kind of visible, personal change is hard to put a price on. A very special shoutout to Karen Smith, the Certified Venus Bliss Max™ Technician who performed all of my treatments. She is exceptionally skilled and knowledgeable, made the entire experience comfortable, and clearly takes real pride in delivering results for her clients. Highly recommend!"
              </p>
            </div>
          </div>
        </div>
      </section>
    </AnimatedPage>
  );
};

export default AestheticServices;
